export function init() {
    $('#btn_close').on('click', () => {
        window.close();
    });
}
